export const createSimpleNoteCreateState = (text = {}) => {
  const now = new Date();
  const dateValue = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  return {
    headerActions: [
      {
        key: 'back',
        label: String(text?.create?.headerActions?.back || 'Volver').trim() || 'Volver',
        icon: 'fa-arrow-left',
        variant: 'secondary',
      },
    ],
    currency: 'MXN',
    customerOptions: [],
    selectedReceiver: null,
    paymentFormOptions: [],
    noteInfo: {
      date: dateValue,
      series: 'NS',
      folio: '-',
      currency: 'MXN',
      paymentForm: '01',
    },
    concepts: [],
    comments: '',
    showConceptModal: false,
    conceptModalMode: 'create',
    editingConceptIndex: -1,
    creatingInlineCustomer: false,
    submittingSimpleNote: false,
    prefillPaymentId: 0,
  };
};
